import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { mergeMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ManifestService } from './manifest.service';
import { Manifest } from 'src/app/admin/models/manifest.model';
import { Router } from '@angular/router';
import {
  SetManifestError,
  LoadManifests,
  SetManifests,
  LoadCurrentManifest,
  SetCurrentManifest,
  CreateManifest,
  GoToCurrentManifest,
} from './manifest.actions';

@Injectable()
export class ManifestEffects {
  loadManifests$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadManifests),
      mergeMap(() =>
        this.manifestService.loadManifests().pipe(
          map((manifests: Manifest[]) => SetManifests({ manifests })),
          catchError((error) => of(SetManifestError({ error }))),
        ),
      ),
    ),
  );

  getManifest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadCurrentManifest),
      mergeMap(({ id }) =>
        this.manifestService.getManifest(id).pipe(
          map((manifest: Manifest) => SetCurrentManifest({ manifest })),
          catchError((error) => of(SetManifestError({ error }))),
        ),
      ),
    ),
  );

  createManifest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateManifest),
      mergeMap(({ values, description }) =>
        this.manifestService.createManifest(description, values).pipe(
          mergeMap((manifest: Manifest) => [
            SetCurrentManifest({ manifest }),
            GoToCurrentManifest({ id: manifest.id }),
          ]),
          catchError((error) => of(SetManifestError({ error }))),
        ),
      ),
    ),
  );

  goToCurrentManifest$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GoToCurrentManifest),
        tap(({ id }) => this.router.navigate(['/admin', 'manifests', id])),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private manifestService: ManifestService,
    private router: Router,
  ) {}
}
